import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React from 'react'
import * as styles from 'src/components/SidenavContent/SidenavContent.style'
import SidenavContentNavGroup from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup'
import { SidenavContentNavGroupDivider } from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup.style'
import SidenavContentNavItem from 'src/components/SidenavContentNavItem/SidenavContentNavItem'
import SvgArrowBack from 'src/components/Svgs/SvgArrowBack'
import { useTranslate } from 'src/localization/Trns'
import { useSettingsNavItems } from 'src/navigation/sidenav/useSettingsNavItems'

export interface SidenavSettingsContentProps {
  onBackClick: () => void
  isSidenavOpen: boolean
}

const SidenavSettingsContent: React.FC<SidenavSettingsContentProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const { navGroups } = useSettingsNavItems({
    isSidenavOpen: props.isSidenavOpen,
  })

  return (
    <div css={styles.SidenavIconLinkColumn}>
      <SidenavContentNavItem
        itemType={'button'}
        id={`profileSettingsNavBack`}
        isSidenavOpen={props.isSidenavOpen}
        isActive={false}
        label={translate('Back')}
        ActiveSvg={
          <SvgArrowBack
            width={20}
            height={20}
            viewBox={'0 0 24 24'}
            fill={text_colorTextSecondary}
          />
        }
        InactiveSvg={
          <SvgArrowBack
            width={20}
            height={20}
            viewBox={'0 0 24 24'}
            fill={text_colorTextSecondary}
          />
        }
        onClick={props.onBackClick}
      />

      {navGroups.map((group, groupIndex) => {
        if (!group.condition) return null

        return (
          <React.Fragment key={groupIndex}>
            {group.showDivider && <SidenavContentNavGroupDivider />}
            <SidenavContentNavGroup
              header={group.header}
              isSidenavOpen={props.isSidenavOpen}
            >
              {group.items.map((item) => (
                <SidenavContentNavItem
                  key={item.id}
                  isSidenavOpen={props.isSidenavOpen}
                  id={item.id}
                  isActive={item.isActive}
                  to={item.to}
                  ActiveSvg={item.activeSvg}
                  InactiveSvg={item.inactiveSvg}
                  label={item.label}
                  expandOptions={item.expandOptions}
                />
              ))}
            </SidenavContentNavGroup>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default SidenavSettingsContent
